// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroThirdPartyBrand_root__tm3cM","logoContainer":"HeroThirdPartyBrand_logoContainer__PFySv"};